import React from 'react';
export function Footer() {
  return <footer className="bg-cream-dark py-12 border-t border-cream-dark text-center px-4" data-id="element-191" data-mp="32wd2cf6gdjt0">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-192" data-mp="3gg0xpz2xhpvj">
        <p className="text-green font-bold text-lg" data-id="element-193" data-mp="32o4ao9g4a660">
          Mega Pack Industrialización de Alimentos en el Aula
        </p>
        <p className="text-slate text-sm" data-id="element-194" data-mp="36qhgexuv642s">
          Material educativo para docentes técnicos de Latinoamérica
          <br data-id="element-195" data-mp="3ugbqj7nstejc" />
          Hecho por especialistas, para docentes de todo el mundo
          hispanohablante.
        </p>
        <div className="flex justify-center gap-4 text-xs text-slate/80 pt-4" data-id="element-196" data-mp="37xvkgeim0i0">
          <a href="#" className="hover:text-terracota" data-id="element-197" data-mp="3ldkdx4j6scq4">
            Términos y condiciones
          </a>
          <a href="#" className="hover:text-terracota" data-id="element-198" data-mp="3qbvm7atu2f68">
            Política de privacidad
          </a>
          <a href="#" className="hover:text-terracota" data-id="element-199" data-mp="29xm24swmjcl7">
            Política de devoluciones
          </a>
          <a href="#" className="hover:text-terracota" data-id="element-200" data-mp="2ezl4q0kji5h3">
            Contacto y soporte
          </a>
        </div>
        <p className="text-slate/60 text-xs pt-4" data-id="element-201" data-mp="3lbdd6ucasbmc">
          © {new Date().getFullYear()} Mega Pack Industrialización de Alimentos
          en el Aula — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}